import { useContext, useEffect } from 'react'
import useNotificationContext from './use-notification-context'
import useModals from 'src/Hooks/useModals'
import { useLocation } from 'react-router-dom'
import { RESTRICTED_ROUTES_TO_DISPLAY_NOTIFICATIONS } from 'src/Libs/notifications/constants'
import { useTypedSelector } from 'src/State/RootReducer'
import { AuthContext } from '@e3dc-react/shell/Libs/authentication'

/**
 * Custom hook to open a notifications modal with mandatory notifications in framework
 */
const useOpenNotificationsModal = (withContent: boolean): void => {
  const { loadNotifications, getMandatoryNotifications } = useNotificationContext()
  const { openNotificationModal } = useModals()
  const location = useLocation()
  const user = useTypedSelector(state => state.user.userData)
  const valid = useContext(AuthContext).valid

  useEffect(() => {
    if (valid && withContent && user) {
      loadNotifications().then(notifications => {
        const mandatoryNotifications = getMandatoryNotifications(notifications)
        const { pathname } = location
        const isRestrictedRoute = RESTRICTED_ROUTES_TO_DISPLAY_NOTIFICATIONS.some(route => pathname.includes(route))

        if (mandatoryNotifications && mandatoryNotifications.length > 0 && !isRestrictedRoute) {
          openNotificationModal()
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valid, user])
}

export default useOpenNotificationsModal
